
import { mapState } from 'vuex'
import { bus } from '~/assets/js/eventBus'
import textTraderTitle from '~/components/textTrader/_title.vue'

export default {
  components: {
    'text-title': textTraderTitle
  },
  inject: ['info'],
  data() {
    const _tiyan = this.info && this.info.softwareInfo ? this.info.softwareInfo : null
    const _ismt5 = this.info && this.info.softwareInfo && this.info.softwareInfo.softwareType == 2
    const _ismt4 = this.info && this.info.softwareInfo && this.info.softwareInfo.softwareType == 1
    const _isziyan = this.info && this.info.softwareInfo && this.info.softwareInfo.softwareType == 4
    const _lineheight = []
    if (this.info && this.info.safety && this.info.safety.regulators && this.info.safety.regulators.length > 0) {
      this.info.safety.regulators.forEach((item, k) => {
        _lineheight.push('auto')
      })
    }

    return {
      ismt5: _ismt5,
      ismt4: _ismt4,
      isziyan: _isziyan,
      Tiyan: _tiyan,
      showall: false,
      lineheight: _lineheight,
      showArrow: false
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    }),
    GetMT4Lv() {
      let status = 0
      if (this.Tiyan && this.Tiyan.softwareQualificationStates > 0) {
        status = this.Tiyan.softwareQualificationStates
      }
      if (status == 11) {
        return 'green'
      } else if (status == 4 || status == 7) {
        return 'yellow'
      } else {
        return 'red'
      }
    }
  },
  mounted() {
    bus.$on('TextTraderArrow', (sa) => {
      if (sa && (sa.pos == 'tiyan' || sa.pos == 'all') && sa.show) {
        this.showArrow = true
      } else {
        this.showArrow = false
      }
    })
    console.log('交易软件体验', this.Tiyan)
  },
  methods: {
    GetDownloadLinkHtml(item) {
      if (!item.Path || item.Path.includes('***')) {
        return `<a alt="${item.Path}" href="javascript:void(0)">${this.$v('下载链接')}</a>`
      } else {
        return `<a href="${item.Path}" target="_blank">${this.$v('下载链接')}</a>`
      }
    },
    show(mark) {
      this.showall = mark
      if (mark) {
        const that = this
        setTimeout(function () {
          that.DealLineHeight()
          that.$forceUpdate()
        }, 300)
      }
    },
    DealLineHeight() {
      if (this.info && this.info.safety && this.info.safety.regulators && this.info.safety.regulators.length > 0) {
        this.info.safety.regulators.forEach((item, k) => {
          const line = this.GetLineHeightByClass('software_tbline' + k) + 'px'
          console.log('line', line)
          this.lineheight[k] = line
        })
      }
    },
    GetLineHeightByClass(cls) {
      const objlist = document.querySelectorAll('.' + cls)
      let hg = 22
      if (objlist && objlist.length > 0) {
        objlist.forEach((item, k) => {
          const height = item.getBoundingClientRect().height
          if (height > hg) {
            hg = height
          }
        })
      }
      return hg
    },
    GetAllPingTai() {
      let ret = ''
      const _pld = this.Tiyan?.softwareInfoDetail?.platforms
      if (_pld && _pld.length > 0) {
        for (let k = 0; k < _pld.length; k++) {
          if (!ret || !ret.includes(_pld[k])) {
            ret += (ret ? ', ' : '') + _pld[k]
          }
        }
      }
      return ret
    },
    GetSoftwareType(type) {
      if (!type) {
        return ''
      }
      let text = ''
      switch (type) {
        case 1:
          text = 'IOS'
          break
        case 2:
          text = 'Android'
          break
        case 3:
          text = 'Windows'
          break
        case 4:
          text = 'MacOS'
          break
        case 5:
          text = 'Web'
          break
      }

      return text
    },
    DealTraderName(content, type) {
      if (!content) {
        return ''
      }
      let ret = content
      if (type == 'text') {
        ret = ret.replace(/\{brokers name}/g, this.info.shortName)
        ret = ret.replace(/\{0}/g, this.info.shortName)
      } else {
        ret = ret.replace('{brokers name}', `<a class="trader" href="${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${this.info.traderCode}.html" target="_blank">${this.info.shortName}</a>`)
        ret = ret.replace(/\{brokers name}/g, this.info.shortName)
        ret = ret.replace('{0}', `<a class="trader" href="${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${this.info.traderCode}.html" target="_blank">${this.info.shortName}</a>`)
        ret = ret.replace(/\{0}/g, this.info.shortName)
      }
      return ret
    },
    ALB() {
      return this.$store.state.LanguageCode == 'ar' ? 'ALB' : ''
    }
  }
}
